import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import "./activeLastBreadcrumb.scss";

const TwoBreadcrumb = ({ mainName, mainLink, activeName }) => {
  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
        <Link to={`/${mainLink}`} className="link">
          {mainName}
        </Link>
        <div aria-current="page">{activeName}</div>
      </Breadcrumbs>
    </div>
  );
};
export default TwoBreadcrumb;
